import requests from '@/utils/requests';

/**
 * 制品仓库列表
 * @param {*} data
 */
export function artifactList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/artifactList',
    method: 'post',
    data
  });
}

/**
 * 制品仓库详情
 * @param {*} data
 */
export function artifactDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/artifactDetail',
    method: 'post',
    data
  });
}

/**
 * 制品仓库版本列表
 * @param {*} data
 */
export function artifactVersionList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/artifactVersionList',
    method: 'post',
    data
  });
}

/**
 * 制品仓库版本详情
 * @param {*} data
 */
export function artifactVersionDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/service/artifact/versionDetail',
    method: 'post',
    data
  });
}
